// SMT微信公众号
import { getSmtOffiaccount } from '@@/api/pcba'

// 缓存请求，防止同一时间多次重复请求
let requestCache = null

const state = {
  smtOffiaccountInfo: {
    url: '', // 二维码地址
    createTime: '', // 生成时间
    expireTime: '', // 有效期
    isBindWx: false, // 是否已经绑定过微信
  }
}

const getters = {
  smtOffiaccountInfo(state) {
    return state.smtOffiaccountInfo
  }
}

const mutations = {
  setSmtOffiaccountInfo(state, data) {
    state.smtOffiaccountInfo = data
  }
}

const actions = {
  // 获取SMT微信公众号信息
  async getSmtOffiaccountInfo({ dispatch, state }) {
    try {
      // 没有正在请求的缓存
      if (!requestCache) {
        requestCache = dispatch('setSmtOffiaccountInfo')
      }
      await requestCache
      return state.smtOffiaccountInfo
    } finally {
      requestCache = null
    }
  },
  // 设置SMT微信公众号信息
  async setSmtOffiaccountInfo({ commit }) {
    const res = await getSmtOffiaccount()
    if (res && res.retCode == 0) {
      commit('setSmtOffiaccountInfo', res.result || {})
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}